module.exports = __webpack_public_path__ + "assets/img/13.1a8027e3.png";